module.exports = __webpack_public_path__ + "img/D201807_1.72fc0501.jpg";